var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: 0,
    y1: 48,
    x2: 48,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E040FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#536DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E5FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 7,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 7,
    fill: "url(#bgGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0367 36.7385L23.6966 10.1273L6.35083 36.7385L23.6966 19.302L41.0367 36.7385Z",
    fill: "#66FF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4849 36.7385H39.1769L31.828 29.2876L24.4849 36.7385Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34119 36.7385H23.0275L15.6844 29.2876L8.34119 36.7385Z",
    fill: "#ED1940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6925 21.2704L16.5073 28.4556L23.6925 35.6407L30.8777 28.4556L23.6925 21.2704Z",
    fill: "#84D1F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cfd4e53e264ae6d04d0738c3d06f63f3.svg";
export { ForwardRef as ReactComponent };